import { ChangeDetectionStrategy, Component } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable, combineLatest, map, filter, startWith } from 'rxjs';
import { WatcherService } from 'src/app/services/watcher.service';
import { AppState } from 'src/app/store/app.reducer';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FooterComponent {
  token$: Observable<string | null>;
  loggedUser$: Observable<any>;
  lang$: Observable<string>;
  hello10Variant$: Observable<boolean>;
  isShopNowActive$: Observable<boolean>;

  constructor(
    private store: Store<AppState>,
    private watcherService: WatcherService,
    private router: Router
  ) {
    this.token$ = this.store.select(state => state.auth.token);
    this.loggedUser$ = this.store.select(state => state.auth.user);
    this.lang$ = this.watcherService.getLang().pipe(startWith('en'));

    const navigationEnd$ = this.router.events.pipe(
      filter(e => e instanceof NavigationEnd),
      map(e => e as NavigationEnd),
      startWith({ url: this.router.url } as NavigationEnd)
    );

    this.hello10Variant$ = navigationEnd$.pipe(
      map(e => e.url.includes('hi10'))
    );

    this.isShopNowActive$ = combineLatest([navigationEnd$, this.lang$]).pipe(
      map(([event, lang]) => event.url.includes(`${lang}/shopnow`))
    );
  }
}
